import { render, staticRenderFns } from "./Reminder.vue?vue&type=template&id=e2767ac4&scoped=true"
import script from "./Reminder.vue?vue&type=script&lang=js"
export * from "./Reminder.vue?vue&type=script&lang=js"
import style0 from "./Reminder.vue?vue&type=style&index=0&id=e2767ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2767ac4",
  null
  
)

export default component.exports